import { api, action, mutate } from "../api/client";
import type { BudgetItemInput } from "@/server/budget";

export type BudgetItemFormInput = Omit<BudgetItemInput, "amount"> & { amount: string };

export const createBudgetItemAction = (tripId: string, input: BudgetItemFormInput) =>
  mutate(() => api.post(`/api/trips/${tripId}/budget-items`, input));

export const updateBudgetItemAction = (itemId: string, tripId: string, input: BudgetItemFormInput) =>
  mutate(() => api.patch(`/api/trips/${tripId}/budget-items/${itemId}`, input));

export const deleteBudgetItemAction = (itemId: string, tripId: string) =>
  mutate(() => api.del(`/api/trips/${tripId}/budget-items/${itemId}`));

/** 환율 조회는 여행과 무관해 로그인만 있으면 된다(원본과 같다). */
export const fetchFxRateAction = (from: string, to: string) =>
  action(() =>
    api.get<{ ok: true; rate: number } | { ok: false }>(
      `/api/fx-rate?from=${encodeURIComponent(from)}&to=${encodeURIComponent(to)}`
    )
  );
